import { render } from "./cardAdmin.vue?vue&type=template&id=d6fa498a"
import script from "./cardAdmin.vue?vue&type=script&lang=js"
export * from "./cardAdmin.vue?vue&type=script&lang=js"

import "./cardAdmin.vue?vue&type=style&index=0&id=d6fa498a&lang=scss"

import exportComponent from "D:\\A-wy-work\\wy-vue-source\\wy-saas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__